import { Component, Input, OnInit } from '@angular/core';
import { AjaxInterceptorService } from '../../interceptors/AjaxInterceptorService';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})


export class LoaderComponent implements OnInit {
  @Input() show: boolean = false;

  constructor(private ajaxInterceptorSvc: AjaxInterceptorService) { }

  ngOnInit() {
    //subscribe to showProgressMask
    this.ajaxInterceptorSvc.showProgressMask.subscribe(
      status => this.show = status
    )
  }
}
